import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
// @ts-ignore
import { ComponentBase, PriceModel, SettingsService, CustomerFormComponent, CustomerType, CustomerInfo  } from 't4core';


@Component({
  selector: 't4-RentalCustomerDetails',
  templateUrl: './RentalCustomerDetails.html',
  styleUrls: ['./RentalCustomerDetails.css'],
})
export class RentalCustomerDetails extends ComponentBase implements OnInit {

  @Input() public customer: CustomerInfo;
  @Output() public valueChanged = new EventEmitter<{ fieldId: string, value: string, isValid: boolean }>();

  @Input() public clientSettingsForm: any;
  @Input() public rentalCustomerType: string;
  @ViewChild("frm") public form: CustomerFormComponent;

  public customerType = CustomerType;
  public isCustomerChanged: Boolean = false;

  public isLoading: boolean = false;


  public dirty(): boolean { return this.form.form.dirty; }
  public validate(): boolean { return this.form.validate(); }
  public ssnInvalid(): boolean { return this.form.form.controls.SSN.invalid }
  public ssnPristine(): boolean { return this.form.form.controls.SSN.pristine }

  public trimField(fieldID: string, trimmed: string): void { this.form.form.controls[fieldID].setValue(trimmed); }

  public markAllAsTouched(): void { this.form.form.markAllAsTouched() }

  public markFormPristine(): void {
    this.form.form.markAsPristine();
  }
  public markFormDirty(): void {
    this.form.form.markAsDirty();
  }

  public update() {
    this.form.update();
  }

  public changeCustomerType(t: CustomerType) {
    if (this.customer.Type == t) return;

    this.customer.Type = t;
    this.isCustomerChanged = true;
    this.form.customerTypeChanged();
  }

  

  constructor() {
    super();

  }

  public async ngOnInit() {
    if (this.rentalCustomerType) {
      if (this.rentalCustomerType == 'Company') {
        this.customer.Type = CustomerType.Company;
      }
      else {
        this.customer.Type = CustomerType.Consumer;
      }
      this.form.customerTypeChanged();
    }
  }

}
